module.exports = __webpack_public_path__ + "img/upload3.a960b9cd.png";